import { createContext } from 'react';

export interface FormContextValue {
  readOnly?: boolean;
  setReadOnly: (v: boolean) => void;
  submitDisabled?: boolean;
  setSubmitDisabled: (v: boolean) => void;
  hidePlaceholderIfReadonly?: boolean;
}
export const FormContext = createContext<FormContextValue>({
  setReadOnly: () => {},
  setSubmitDisabled: () => {},
});
